"use client";
import { ArrowRightIcon } from "@heroicons/react/24/outline";
import { useRouter } from "next/navigation";

export default function LeftButtonComp({
  item,
  selectedItem,
  onClick,
  href,
}: {
  item: any;
  selectedItem: any;
  onClick?: any;
  href?: string;
}) {
  const router = useRouter();
  const handleOnClick = () => {
    if (href) {
      router.push(href);
    } else {
      onClick(item);
    }
  };

  return (
    <button
      className="w-full py-2 flex justify-between items-center ps-4 border-l-2 border-gray-400 disabled:border-green disabled:text-green text-left"
      disabled={selectedItem?.id === item.id}
      onClick={handleOnClick}
    >
      <span>{item.name} </span>
      <ArrowRightIcon className="size-4 hidden lg:block" />
    </button>
  );
}
